import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useMockAuth } from '../contexts/MockAuthContext';

// Toggle between real Firebase auth and mock auth
const USE_MOCK_AUTH = false;

const ProtectedRoute = ({ children, requiredRole }) => {
  const realAuth = useAuth();
  const mockAuth = useMockAuth();
  const location = useLocation();
  const { currentUser, userRole, isLoading: authLoading } = USE_MOCK_AUTH ? mockAuth : realAuth;

  // Persisted role fallbacks
  const storedRole = typeof window !== 'undefined'
    ? (sessionStorage.getItem('userRole') || localStorage.getItem('userRole'))
    : null;
  const effectiveRole = userRole || storedRole;

  // If not logged in, go to login
  if (!currentUser) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // While auth context is loading or role is not yet known, don't bounce the user.
  // This prevents wrong redirects on hard reload of /business/* or /admin/*.
  if (requiredRole && !effectiveRole) {
    return children;
  }

  // If role is known and mismatched, redirect to the right dashboard
  if (requiredRole && effectiveRole !== requiredRole) {
    if (effectiveRole === 'customer') {
      return <Navigate to="/customer/dashboard" replace />;
    } else if (effectiveRole === 'business') {
      return <Navigate to="/business/dashboard" replace />;
    } else if (effectiveRole === 'admin') {
      return <Navigate to="/admin/dashboard" replace />;
    }
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
